import React from "react";

interface TableDetailErrorBoundaryProps {
  children: React.ReactNode;
}

interface TableDetailErrorBoundaryState {
  hasError: boolean;
}

// Keeps a throwing sub-component from unmounting the whole table.
class TableDetailErrorBoundary extends React.Component<
  TableDetailErrorBoundaryProps,
  TableDetailErrorBoundaryState
> {
  state: TableDetailErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): TableDetailErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default TableDetailErrorBoundary;
